var CalculatorDenialManagement = (function($) {

    // Elements...
    var $calculator, $group1, $group2, $group3, $group4,
        $slider1, $slider2, $slider3, $slider4,
        $text1, $text2, $text3, $text4,
        $handle1, $handle2, $handle3, $handle4,
        $result1, $result2;

    // Calculation constraints...
    var constraints = {
        avg_appeals_denials: 0.67,
        avg_manual_time:     0.5,
        avg_work_time:       0.0833
    };

    // Slider config...
    var slider_config = {
        orientation: 'horizontal',
        range: 'min',
        slide: function() {
            calculate()
        },
        stop: function() {
            calculate()
        },
    };

    /**
     * Configure calculator...
     */
    function init() {
        $calculator = $('[data-calculator="denial-management"]');
        $group1     = $('[data-slider-group=1]', $calculator);
        $group2     = $('[data-slider-group=2]', $calculator);
        $group3     = $('[data-slider-group=3]', $calculator);
        $group4     = $('[data-slider-group=4]', $calculator);

        $slider1    = $('[data-slider]', $group1);
        $slider2    = $('[data-slider]', $group2);
        $slider3    = $('[data-slider]', $group3);
        $slider4    = $('[data-slider]', $group4);

        $text1      = $('[data-slider-text]', $group1);
        $text2      = $('[data-slider-text]', $group2);
        $text3      = $('[data-slider-text]', $group3);
        $text4      = $('[data-slider-text]', $group4);

        $handle1    = $('[data-slider-handle]', $group1);
        $handle2    = $('[data-slider-handle]', $group2);
        $handle3    = $('[data-slider-handle]', $group3);
        $handle4    = $('[data-slider-handle]', $group4);

        $result1    = $('[data-result=1]', $calculator);
        $result2    = $('[data-result=2]', $calculator);

        // Configure sliders...
        $slider1.slider($.extend(slider_config, {
            min:   500,
            max:   500000,
            value: 15000,
            step:  500,
            create: function() {
                $handle1.text('<  >');
            }
        }));

        $slider2.slider($.extend(slider_config, {
            min:   1,
            max:   20,
            value: 8,
            step:  1,
            create: function() {
                $handle2.text('<  >');
            }
        }));

        $slider3.slider($.extend(slider_config, {
            min:   100,
            max:   50000,
            value: 1000,
            step:  100,
            create: function() {
                $handle3.text('<  >');
            }
        }));

        $slider4.slider($.extend(slider_config, {
            min:   0,
            max:   10000,
            value: 200,
            step:  100,
            create: function() {
                $handle4.text('<  >');
            }
        }));

        // Calculate for initial load...
        calculate();
    }

    /**
     * Calculate values...
     */
    function calculate() {
        var monthly_claim_volume  = $slider1.slider('value'),
            denial_rate           = $slider2.slider('value') / 100,
            avg_claim_value       = $slider3.slider('value'),
            appeals_per_month     = $slider4.slider('value'),
            metric1               = (monthly_claim_volume * denial_rate) * constraints.avg_appeals_denials,
            metric2               = (appeals_per_month * constraints.avg_manual_time) / constraints.avg_work_time,
            minuend               = (metric1 > metric2) ? metric2 : metric1,
            additional_packages   = minuend - appeals_per_month,
            monthly_package_value = additional_packages * avg_claim_value,
            annual_savings        = monthly_package_value * 12,
            monthly_time_savings  = (appeals_per_month * constraints.avg_manual_time)
                                    - (appeals_per_month * constraints.avg_work_time),
            annual_time_savings   = monthly_time_savings * 12;

        // Populate outputs...
        $text1.html($slider1.slider('values', 210500).toLocaleString());
        $text2.html($slider2.slider('value') + '%');
        $text3.html('$' + $slider3.slider('values', 30000).toLocaleString());
        $text4.html($slider4.slider('values', 4500).toLocaleString());

        $result1.html('$' + Math.round(annual_savings).toLocaleString());
        $result2.html(Math.round(annual_time_savings.toFixed(2)).toLocaleString());
    }

    return {
        init: init,
    }

})(jQuery);

jQuery(document).ready(function() {
    CalculatorDenialManagement.init();
});